import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { OrganisationsProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const ORGANISATIONS_QUERY = graphql`
query NodeAllOrganisationsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Organisations" } }) {
    nodes {
      data
    }
  }
}
`;

export const OrganisationsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(ORGANISATIONS_QUERY), 'items')}>{children}</Provider>;
};
